const dashboardRouter = {
  component: () => import('@/modules/dashboard/layouts/DashboardLayout.vue'),
  children: [
    { path: '', redirect: { name: 'dashboard-courses' } },
    {
      path: 'cursos',
      name: 'dashboard-courses',
      meta: { page: { title: 'Revisiones de proyecto' } },
      component: () => import('@/modules/dashboard/pages/courses/Courses.vue'),
    },
    { path: 'especializaciones', redirect: { name: 'dashboard-courses' } },
    { path: 'especializaciones/:project', redirect: { name: 'dashboard-courses' } },
    { path: 'cursos/:project', redirect: { name: 'dashboard-courses' } },
    { path: 'comentarios', redirect: { name: 'dashboard-courses' } },
    { path: 'comisiones', redirect: { name: 'dashboard-courses' } },
    { path: 'chats', redirect: { name: 'dashboard-courses' } },
  ]
}

export default dashboardRouter
